import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { AboutComponent } from './about/about.component';
import { ContactusComponent } from './contactus/contactus.component';
import { ProjectsComponent } from './projects/projects.component';
import { ServicesComponent } from './services/services.component';
import { AppHttpService } from './AppServices/app.httpservices';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { LoginComponent } from './login/login.component';
import { AppAuthenticationService } from './AppServices/app.authentication';
import { AdminAuthGuardService } from './AppServices/app.adminguard';
import { AppSessionStorage } from './AppServices/app.sessionstorage';
import { AdminprojectsComponent } from './adminprojects/adminprojects.component';
import { AdminProjectListComponent } from './admin-project-list/admin-project-list.component';
import { BlogComponent } from './blog/blog.component';
import { BlogDetailComponent } from './blog-detail/blog-detail.component';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import { DeleteComponent } from './delete/delete.component';
import {MatDialogModule} from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtInterceptor } from './AppServices/app.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { NgxMaskModule, IConfig } from 'ngx-mask'

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    AboutComponent,
    ContactusComponent,
    ProjectsComponent,
    ServicesComponent,
    LoginComponent,
    AdminprojectsComponent,
    AdminProjectListComponent,
    DeleteComponent,
    BlogComponent,
    BlogDetailComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatTableModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    NgxMaskModule.forRoot()
  ],
  exports: [
    MatTableModule,
    MatTooltipModule,
    MatDialogModule,
    MatProgressSpinnerModule
   
  ],
  entryComponents: [
    DeleteComponent
  ], 
  providers: [AppHttpService, AppAuthenticationService, AdminAuthGuardService, AppSessionStorage,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
